<template>
  <div class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="合同终止与作废申请审核"></Title>

    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>关联合同：</span>{{ contractDetail.contractName || '-' }}</div>
        <div class="contract-apply-item"><span>操作类型：</span>{{ applyForm.operationType == '2' ? '合同作废' : '合同终止' }}</div>
        <div class="contract-apply-item" v-if="applyForm.operationType == '1'">
          <span>终止日期：</span>{{ applyForm.endTime | getDate }}
        </div>
        <div class="contract-apply-item reason-item">
          <span>{{ applyForm.operationType == '2' ? '作废原因' : '终止原因' }}：</span>
          <div class="reason-text">{{ applyForm.endReason || '-' }}</div>
        </div>
      </div>
      <img
        v-show="applyForm.approveState && applyForm.approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
    </div>

    <!-- 合同附件 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同附件</p>
      <el-row :gutter="24">
        <el-col :span="24">
          <span class="contract-base-title">合同附件：</span>
          <div>
            <div v-for="(item, index) in fileList" :key="index">
              <div class="contract-file-inform">
                <img
                  width="32"
                  height="32"
                  class="mr10"
                  :src="
                    item.type == 'word'
                      ? require('../../assets/images/word_icon.png')
                      : require('../../assets/images/pdf_icon.png')
                  "
                  alt=""
                />
                <span> {{ item.name }}</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看详情</span>
                <a
                  :href="item.path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: none; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="fontC-4fa1a4 c-pointer ml10"
                  >下载</a
                >
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <span class="contract-base-title">合同重点内容说明：</span>
          <div class="contract-base-content">{{ contractDetail.importantContent || '-' }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 合同信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">合同信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">甲方名称：</span>
          <div class="contract-base-content">{{ contractDetail.tenantName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">乙方名称：</span>
          <div class="contract-base-content">{{ contractDetail.serviceTenantName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">公司类型：</span>
          <div class="contract-base-content">{{ contractDetail.enterpriseCate | commonFilterName('平台企业类型') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合同类型：</span>
          <div class="contract-base-content">{{ contractDetail.contractType | commonFilterName('合同类型') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">业务类型：</span>
          <div class="contract-base-content">{{ contractDetail.contractContentType == '1' ? '业务收入' : '业务支出' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">业务类型内容：</span>
          <div class="contract-base-content" v-if="contractDetail.contractContentType == '1'">
            {{ contractDetail.contractContent | commonFilterName('业务收入类型') }}
          </div>
          <div class="contract-base-content" v-else>{{ contractDetail.contractContent | commonFilterName('业务支出类型') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">项目经理：</span>
          <div class="contract-base-content">{{ contractDetail.projectManagerName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合同金额(元)：</span>
          <div class="contract-base-content">{{ contractDetail.contractMoney | numDigit }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">发票方式：</span>
          <div class="contract-base-content">{{ contractDetail.invoiceMode || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">结算依据：</span>
          <div class="contract-base-content">{{ contractDetail.balanceBasis || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">维保条件：</span>
          <div class="contract-base-content">{{ contractDetail.maintainCondition | commonFilterName('维保条件') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">任务价格是否含税：</span>
          <div class="contract-base-content">{{ contractDetail.isContainTax | getVisible }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否垫资：</span>
          <div class="contract-base-content">{{ contractDetail.isAdvanceMoney | getVisible }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否补充协议：</span>
          <div class="contract-base-content">{{ contractDetail.isSupplementAgreement | getVisible }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 邮寄信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">邮寄信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">是否需要邮寄：</span>
          <div class="contract-base-content">{{ contractDetail.isMail | getVisible }}</div>
        </el-col>
        <el-col :span="12" v-if="contractDetail.isMail == 'Y'">
          <span class="contract-base-title">收件人姓名：</span>
          <div class="contract-base-content">{{ contractDetail.receiveName || '-' }}</div>
        </el-col>
        <el-col :span="12" v-if="contractDetail.isMail == 'Y'">
          <span class="contract-base-title">收件人电话：</span>
          <div class="contract-base-content">{{ contractDetail.receiveMobile || '-' }}</div>
        </el-col>
        <el-col :span="12" v-if="contractDetail.isMail == 'Y'">
          <span class="contract-base-title">收件人地址：</span>
          <div class="contract-base-content">{{ contractDetail.mailAddress || '-' }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 产品信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">产品信息</p>
      <el-row :gutter="24" class="mb10">
        <el-col :span="24">
          <span class="contract-base-title">产品名称：</span>
          <div class="contract-base-content">{{ getProductName(contractDetail.contractProductList) }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 付款方式 -->
    <div class="contract-base-box">
      <p class="contract-base-name">付款方式</p>
      <el-row :gutter="24" class="mb10">
        <el-col :span="12">
          <span class="contract-base-title">付款方式：</span>
          <div class="contract-base-content">{{ contractDetail.payType | commonFilterName('付款方式') }}</div>
        </el-col>
      </el-row>
      <el-row
        :gutter="24"
        class="mb10"
        v-if="contractDetail.payType !== '1'"
        v-for="(item, index) in payTypeJsonList"
        :key="index"
      >
        <el-col :span="12">
          <span class="contract-base-title">回款方式：</span>
          <div class="contract-base-content" v-if="contractDetail.payType == '4'">
            {{ item.selectType | commonFilterName('费用类型') }}
          </div>
          <div class="contract-base-content" v-if="contractDetail.payType == '2'">
            {{ item.selectType | commonFilterName('季度选项') }}
          </div>
          <div class="contract-base-content" v-if="contractDetail.payType == '3'">
            {{ item.selectType | commonFilterName('年度选项') }}
          </div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">{{ contractDetail.payType !== '4' ? '回款金额(元)' : '回款比例(%)' }}：</span>
          <div class="contract-base-content">{{ item.selectValue }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mb10" v-if="contractDetail.payType == '1'">
        <el-col :span="12">
          <span class="contract-base-title">收费比例(%)：</span>
          <div class="contract-base-content">{{ chargeRate }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">下发扣除税点(%)：</span>
          <div class="contract-base-content">{{ sendTaxDeduction }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否内扣：</span>
          <div class="contract-base-content">{{ contractDetail.isInsideDeduction | getVisible }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 银行信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">银行信息</p>
      <el-row :gutter="24" class="mb10" v-for="(item, index) in contractDetail.contractBankList" :key="index">
        <el-col :span="12">
          <span class="contract-base-title">开户银行：</span>
          <div class="contract-base-content">{{ item.bankName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开户账号：</span>
          <div class="contract-base-content">{{ item.bankAccount || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开户行号：</span>
          <div class="contract-base-content">{{ item.bankNo || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">税号：</span>
          <div class="contract-base-content">{{ item.bankTaxNo || '-' }}</div>
        </el-col>
      </el-row>
    </div>

    <!-- 签约任务 -->
    <div class="contract-base-box" v-show="contractDetail.contractTaskDetailList && contractDetail.contractTaskDetailList.length">
      <p class="contract-base-name">签约任务</p>
      <div class="content-main-box" style="height: auto">
        <el-table border stripe :data="contractDetail.contractTaskDetailList">
          <el-table-column :resizable="false" show-overflow-tooltip label="任务名称" width="180" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.oldTaskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column :resizable="false" label="项目任务名称" width="180" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column :resizable="false" show-overflow-tooltip label="任务价格(元)" width="160" header-align="center" align="right">
            <template slot-scope="scope">
              <div v-if="scope.row.priceType == 2">{{ scope.row.taskPrice | numDigit }} - {{ scope.row.maxTaskPrice | numDigit }}</div>
              <div v-if="scope.row.priceType == 1">{{ scope.row.taskPrice | numDigit }}</div>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" show-overflow-tooltip label="备注" width="100" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskDescription || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 合同盖章附件 -->
    <div class="contract-base-box" v-if="contractDetail.logisticsInfoDTO && contractDetail.logisticsInfoDTO.bizGuid">
      <p class="contract-base-name">合同盖章附件</p>
      <el-row :gutter="24">
        <el-col :span="12" v-if="contractDetail.isMail == 'Y'">
          <span class="contract-base-title">快递公司：</span>
          <div class="contract-base-content">{{ contractDetail.logisticsInfoDTO.expressCompany || '-' }}</div>
        </el-col>
        <el-col :span="12" v-if="contractDetail.isMail == 'Y'">
          <span class="contract-base-title">快递单号：</span>
          <div class="contract-base-content">{{ contractDetail.logisticsInfoDTO.expressNo || '-' }}</div>
        </el-col>
      </el-row>
      <!-- 附件 -->
      <div class="contract-base-box">
        <div class="contract-apply-file">
          <span>合同附件：</span>
          <div>
            <div v-for="(item, index) in ccFileList" :key="index">
              <div class="contract-file-inform">
                <img
                  width="32"
                  height="32"
                  class="mr10"
                  :src="
                    item.type == 'word'
                      ? require('../../assets/images/word_icon.png')
                      : require('../../assets/images/pdf_icon.png')
                  "
                  alt=""
                />
                <span> {{ item.fileName || item.name }}</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看详情</span>
                <a
                  :href="item.path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: none; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="fontC-4fa1a4 c-pointer ml10"
                  >下载</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>

    <!-- 提交 -->
    <div class="submit-btn-box submit_btn_wrap" v-if="applyForm">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>

    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>

    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import { getContractOperationDetail } from '@/api/contractOperation.js';
export default {
  components: {
    Title,
  },
  data() {
    return {
      flowType: '00044',
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      fullscreenLoading: false,
      applyForm: {},
      contractDetail: {},
      fileList: [],
      ccFileList: [],
      // 流程
      srcs: '',
      iframeSh: true,
      currentStaffGuid: null,
      payTypeJsonList: [],
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.getPageDetail();
    this.getBpmnUrl();
  },
  methods: {
    // 状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.applyForm.approveState);
    },
    // 查看附件
    toSee(item, index) {
      let path = item.path;
      if (path.indexOf('.pdf') > -1 || path.indexOf('.PDF') > -1) {
        window.open(path);
      } else {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path));
      }
    },
    // 获取操作按钮显隐
    getBtnState(btnType) {
      return workFlowCommon.getBtnState(
        btnType,
        this.applyForm.approveState,
        this.$route.query.approveStaffGuid,
        this.currentStaffGuid,
        this.applyForm.staffGuid,
        this.applyForm.bizApproveState
      );
    },
    // 获取详情
    async getPageDetail() {
      this.fullscreenLoading = true;
      const { data } = await getContractOperationDetail(this.$route.query.guid);
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let detail = data.data;
      this.applyForm = {
        ...detail,
        endTime: detail.endTime ? this.$moment(detail.endTime).format('YYYY-MM-DD') : null,
      };
      this.contractDetail = detail.contractDetail || {};
      if (this.contractDetail.payType !== '1' && this.contractDetail.payTypeJson) {
        this.payTypeJsonList = JSON.parse(this.contractDetail.payTypeJson);
      } else {
        this.payTypeJsonList = [];
      }
      if (this.contractDetail.contractUrl) {
        this.fileList = JSON.parse(this.contractDetail.contractUrl);
        this.fileList.forEach((i) => {
          i.type = i.path && (i.path.indexOf('.pdf') > -1 || i.path.indexOf('.PDF') > -1) ? 'pdf' : 'word';
        });
      } else {
        this.fileList = [];
      }
      if (this.contractDetail.electronicContractFileList) {
        this.ccFileList = this.contractDetail.electronicContractFileList;
        this.ccFileList.forEach((i) => {
          i.type = i.path && (i.path.indexOf('.pdf') > -1 || i.path.indexOf('.PDF') > -1) ? 'pdf' : 'word';
        });
      } else {
        this.ccFileList = [];
      }
    },
    getProductName(list) {
      let nameList = [];
      if (list && list.length > 0) {
        list.forEach((i) => {
          nameList.push(i.productName);
        });
      }
      return nameList.join(' , ') || '-';
    },
    getBpmnUrl() {
      if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
      } else {
        this.iframeSh = false;
      }
    },
    // 撤销
    toRevoke() {
      this.$confirm('确定撤销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: this.applyForm.approveGuid,
            flowType: this.flowType,
            approveStaffGuid: this.currentStaffGuid,
          };
          this.fullscreenLoading = true;
          this.api
            .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.fullscreenLoading = false;
                this.$message.success(messageConfig.FLOW_CANCEL);
                sessionStorage.refresh = 1;
                this.$router.go(-1);
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    // 重新提交
    reSubmit() {
      this.$router.push({
        path: '/contractTerminationAdd',
        query: {
          guid: this.$route.query.guid,
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    toPass() {
      this.approveSuggest = '';
      this.passDialogVisible = true;
    },
    toReject() {
      this.approveSuggest = '';
      this.rejectDialogVisible = true;
    },
    // 通过
    toPassSubmit() {
      let query = {
        guid: this.applyForm.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.currentStaffGuid,
      };
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(messageConfig.FLOW_PASS);
            sessionStorage.refresh = 1;
            this.passDialogVisible = false;
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 驳回
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.applyForm.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.currentStaffGuid,
      };
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success(messageConfig.FLOW_REJECT);
            sessionStorage.refresh = 1;
            this.rejectDialogVisible = false;
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
  computed: {
    chargeRate() {
      if (!this.contractDetail.chargeRate) {
        return '-';
      }
      return this.$options.filters.numDigit(this.contractDetail.chargeRate);
    },
    sendTaxDeduction() {
      if (!this.contractDetail.sendTaxDeduction) {
        return '-';
      }
      return this.$options.filters.numDigit(this.contractDetail.sendTaxDeduction);
    },
  },
};
</script>

<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
  margin-bottom: 10px;
}
.contract-apply-item span {
  color: #666666;
}
.contract-apply-item.reason-item {
  width: 90%;
  border-right: none;
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.contract-apply-item.reason-item .reason-text {
  flex: 1;
  color: #212121;
  word-break: break-all;
  white-space: pre-wrap;
  text-align: left;

}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 32px;
}
.contract-file-inform {
  display: flex;
  align-items: center;
}
.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 合同信息 */
.contract-base-box .el-col-12,
.contract-base-box .el-col-24 {
  display: flex;
  line-height: 22px;
  margin-bottom: 20px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title,
.el-col-24:nth-child(2n + 1) .contract-base-title {
  flex-shrink: 0;
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title,
.el-col-12:nth-child(2n) .contract-base-title {
  flex-shrink: 0;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-24 .contract-base-title {
  flex-shrink: 0;
  width: 154px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
</style>
